var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isOverridden)?_c('line',{class:_vm.classObject,attrs:{"x1":_vm.percents(_vm.setup.x1),"y1":_vm.percents(_vm.setup.y1),"x2":_vm.percents(_vm.setup.x2),"y2":_vm.percents(_vm.setup.y2)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }